<i18n>
{
	"en": {
		"goodsType": "Goods Type",
		"selectGoodsType": "Select goods type"
	},
	"no": {
		"goodsType": "Godstype",
		"selectGoodsType": "Velg godstype"
	}
}
</i18n>
<template>
	<t-form-group :title="$t('goodsType')" rowGap="5px">
		<t-select
			:items="goodsTypes"
			:selectedItem="selectedItem"
			:disabled="disabled || hasNoGoodsTypes"
			width="100%"
			v-bind="$attrs"
			relative
			showPopoverOnFocus
			:enableFocusNextOnKeyboardSelect="enableFocusNextOnKeyboardSelect"

			@change="$emit('change', $event)"
			@select="$emit('select', $event)"
		>
			<template #displayedValue>
				<div v-if="selectedItem && 'name' in selectedItem" class="item-wrapper">
					<t-timpex-icon
						:icon="getGoodsTypeIcon(selectedItem.iconId)"
						color="blue"
						size="sm"
					/>
					<div>{{ `${selectedItem.name}` }}</div>
				</div>
				<div v-else>
					{{ $t('selectGoodsType') }}
				</div>
			</template>
			<template #optionItem="{ item, isSelected }">
				<t-menu-icon-option-item
					:key="item.id"
					:icon="item.icon"
					:value="item"
					:displayName="item.name"
					:selected="isSelected"
				/>
			</template>
		</t-select>
	</t-form-group>
</template>

<script>
import { goodsTypesIcons } from '@/core';
import { mapState, mapActions } from './store/goodsTypes.store';

export default {
	name: 'GoodsTypesFormInput',
	inheritAttrs: false,
	props: {
		selectedItem: Object,
		disabled: {
			type: Boolean,
			default: false
		},
		enableFocusNextOnKeyboardSelect: Boolean,
	},
	computed: {
		...mapState(['goodsTypes']),
		hasNoGoodsTypes() {
			return !this.goodsTypes || this.goodsTypes.length === 0;
		}
	},
	mounted() {
		this.getGoodsTypes();
	},
	methods: {
		...mapActions(['getGoodsTypes']),
		getGoodsTypeIcon(iconId) {
			let icon = goodsTypesIcons.getById(iconId);
			return icon;
		},
	},
};

</script>

<style lang="scss" scoped>
.item-wrapper {
	display: flex;
	align-items: center;
	justify-content: flex-start;


	div {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	:not(:first-child) {
		margin-left: 10px;
	}
}
</style>
